import {writable} from 'svelte/store';

import {BODY_TYPES} from '../../constants/bodies-by-type';

const buildDefault = () => {
  return BODY_TYPES.reduce((flags, type) => {
    flags[type] = true;
    return flags;
  }, {});
};

const createStore = () => {
  const {subscribe, set} = writable(buildDefault());

  const reset = () => {
    set(buildDefault());
  };

  return {
    subscribe,
    set,
    reset
  };
};

export const bodyTypeFlagsStore = createStore();
